import { useEffect, useRef, useState } from 'react';
import { ref, onValue, off, goOnline, goOffline } from 'firebase/database';
import { db } from '../config/firebase';

function useFirebaseSync(path, callback) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  const [revision, setRevision] = useState(0);

  // Reconnect when app returns to foreground
  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        goOnline(db);
        // Force re-subscribe by bumping revision
        setRevision((r) => r + 1);
      }
    };

    const handleOnline = () => {
      goOnline(db);
      setRevision((r) => r + 1);
    };

    document.addEventListener('visibilitychange', handleVisibility);
    window.addEventListener('online', handleOnline);
    window.addEventListener('focus', handleVisibility);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('focus', handleVisibility);
    };
  }, []);

  useEffect(() => {
    if (!path) return;

    const dbRef = ref(db, path);
    const handler = onValue(dbRef, (snapshot) => {
      callbackRef.current(snapshot.val());
    });

    return () => off(dbRef, 'value', handler);
  }, [path, revision]);
}

export { useFirebaseSync };
